import { apiAdd, apiDelete, apiGet, apiUpdate } from "../../../API/Service/apiClient";

export const handleGetSublimation_list = async({filter,setSizes,setLoading}) => {
  setLoading(true);
  try {
    const resData = await apiGet("sublimation", filter);    
    setSizes(resData?.data);
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false);
  }
};

export const handleSublimation_Create =
 async({setLoaderADES,sizes,setSizes,values}) => {
  setLoaderADES({create:true});
  try {    
    
    const resData = await apiAdd("sublimation", values);        
    if(resData?.data?.id > 0){
      setSizes([...sizes, { ...values, id: resData?.data?.id }]);
    }else{
      alert("Something went wrong! Please try again")
    }
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoaderADES(null);
  }
};

export const handleSublimation_Update =
 async({setLoaderADES,item}) => {
  setLoaderADES({update:item?.id});
  try {    
    const resData = await apiUpdate("sublimation", item);        
    if(resData?.data?.id > 0){      
    }else{
      alert("Something went wrong! Please try again")
    }
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoaderADES(null);
  }
};

export const handleSublimation_Delete =
 async({setLoaderADES,setSizes,id}) => {
  setLoaderADES({delete:id});
  try {    
    let data={id:id}
    const resData = await apiDelete("sublimation", data);    
    if(resData?.data > 0){
      setSizes(prevSizes => prevSizes.filter(row => row.id !== id));
    }else{
      alert("Something went wrong! Please try again")
    }   
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoaderADES(null);
  }
};

export const handleInputChange = (id, field, value,setSizes,sizes) => {
  const updated = sizes.map((row) =>
    row.id === id ? { ...row, [field]: value } : row
  );
  setSizes(updated);
};
